
import React, { useState, useEffect, useRef } from "react";
import { appConstants } from "../../utils/constants";

import SuccessIcon from "../../assets/images/success.svg";
import { useDashboardContext } from "../../context/customhook/dashboardHook";

function DynamicQuestionCell({
  questions,
  language,
  headerTitles,
  onQuestionClick,
}) {
  const isSuccess = questions?.some((q) => q.questionId === q.selectedId);
  const containerRef = useRef(null);

  //We manage the display of the feedback option by controlling it through DashboardStates.
  const { dashboardStates, setDashboardStates } = useDashboardContext();

  const [englishTitle, setEnglishTitle] = useState(null);
  const [arabicTitle, setArabicTitle] = useState(null);

  const renderQuestionOptions = (options) => {
    //Displaying questions in a horizontal row.
    return options.map((option) => (
      <button
        key={option.questionId}
        className={`question-button ${
          option.questionId === option.selectedId
            ? "question-button-selected"
            : "question-button"
        }`}
        onClick={() => questionOnClick(option)}
      >
        {language !== null && language.includes(appConstants.en)
          ? option.optionEnglish
          : option.optionArabic}
      </button>
    ));
  };

  useEffect(() => {
    if (headerTitles) {
      setEnglishTitle(headerTitles.questionEnglish);
      setArabicTitle(headerTitles.questionArabic);
    } else {
      // If headerTitles is null or undefined, set both titles to null
      setEnglishTitle(null);
      setArabicTitle(null);
    }
  }, [headerTitles]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  //Implementation of click events in the Dynamic Questions class
  const questionOnClick = (selectedValue) => {
    setDashboardStates((previousState) => {
      return {
        ...previousState,
        childQuestionId: selectedValue?.questionId,
      };
    });
    onQuestionClick(selectedValue);
  };

  return (
    <div className="question-container" ref={containerRef}>
      {isSuccess ? (
        <img src={SuccessIcon} alt="logo" className="success-img" />
      ) : null}
      <div className="container-title">
        <label className="container-titel-label">
          {language !== null && language.includes(appConstants.en)
            ? englishTitle
            : arabicTitle}
        </label>
      </div>
      <div className="list">
        {questions ? (
          renderQuestionOptions(questions) // No selected option for current question set
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
}

export default DynamicQuestionCell;
